module.exports = __webpack_public_path__ + "static/img/js_2.0a3b233.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coretesc/js_2.png
// module id = V2dM
// module chunks = 1